<template>
  <div class="empty-shop-rating"></div>
</template>
<style scoped lang="scss">
.empty-shop-rating {
  //background-color: #7b7b7b;
  height: 16px;
  @include lg-block {
    height: 20px;
  }
}
</style>
